import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Loader } from 'semantic-ui-react';
import CenterizedLayout from '../layouts/CenterizedLayout';
import ProjectForm from '../components/Projects/ProjectForm';
import SurveyCreationForm from '../components/Projects/SurveyCreationForm';
import { QUESTIONS_DEFAULT } from '../components/Projects/ProjectForm/QualificationQuestions';
import DataContext from '../contexts/DataContext';
import MessageContext from '../contexts/MessageContext';
import { CREATE_PROJECT } from '../queries/project';
import { MANAGED_PROJECTS } from '../queries/profile';

const PROJECT_DEFAULT = {
  type: '',
  title: '',
  description: '',
  keywords: [],
  targetN: 1,
  qualificationQuestions: QUESTIONS_DEFAULT,
};

const ProjectNew = ({ onCreate, onCancel }) => {
  const history = useHistory();
  const { user } = useContext(DataContext);
  const { setCreatedProject, setErrorPopup } = useContext(MessageContext);

  const [newSurveyProject, setNewSurveyProject] = useState(false);

  const [createProject, { loading }] = useMutation(CREATE_PROJECT, {
    // Only refetches if MANAGED_PROJECTS is currently active (e.g. an
    // invite modal is open); otherwise the next consumer will fetch fresh.
    refetchQueries: [{ query: MANAGED_PROJECTS }],
    onCompleted: (data) => {
      setCreatedProject(data.createProject);
      onCreate?.();
    },
    onError: (err) => {
      setErrorPopup({
        title: 'Failed to craete a project',
        content: err.message,
      });
    },
  });

  const submitCreateProject = (newProject, file = null) => {
    const currentTeamId = user.currentTeam?.id;

    createProject({
      variables: {
        input: {
          ...newProject,
          team: currentTeamId,
          status: 'Draft',
          service_type: 'Self-Service',
          start_date: new Date(),
          end_date: new Date(new Date().setMonth(new Date().getMonth() + 1)),
        },
        file,
      },
    });
  };

  const handleSubmit = (newProject) => {
    if (newProject.type === 'Survey') {
      setNewSurveyProject(newProject);
    } else {
      submitCreateProject(newProject);
    }
  };

  const cancel = () => {
    if (onCancel) onCancel();
    else history.push('/projects');
  };

  return (
    <CenterizedLayout
      title="Create new project"
      description="Enter the project details below.
        The information you provide here will be shared with the experts invited to the project."
    >
      <div id="create-project">
        <Loader active={loading} content="loading" />
        {newSurveyProject ? (
          <SurveyCreationForm
            project={newSurveyProject}
            loading={loading}
            submit={submitCreateProject}
            onCancel={cancel}
          />
        ) : (
          <ProjectForm
            project={PROJECT_DEFAULT}
            loading={loading}
            submit={handleSubmit}
            onCancel={cancel}
          />
        )}
      </div>
    </CenterizedLayout>
  );
};

export default ProjectNew;
